//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: "PriceCalculator",
  props: {
    block: {
      type: Object,
      required: true,
    },
    language: {
      type: String,
      default: "de",
    },
  },
  data() {
    return {
      eventdauer: 0,
      zuschauer: 0,
      events: 0,
      tweenedTraffic: 0,
      showResetButton: false,
    };
  },
  methods: {
    onNumberInput(field, event) {
      let val = event.target.value;
      // Eliminar ceros a la izquierda, pero si la cadena queda vacía poner '0'
      val = val.replace(/^0+(?=\d)/, "");
      if (val === "") val = "0";

      // Actualizar el dato como número
      this[field] = Number(val);
    },
    resetTraffic() {
      this.eventdauer = 0;
      this.zuschauer = 0;
      this.events = 0;
      this.tweenedTraffic = 0;
      this.showResetButton = false;
    },
  },
  computed: {
    traffic() {
      // Coerce falsy values (null, '', undefined) to 0
      const eventdauer = this.eventdauer || 0;
      const zuschauer = this.zuschauer || 0;
      const events = this.events || 0;

      if (eventdauer > 0 && zuschauer > 0 && events > 0) {
        return Math.round(2.63671875 * eventdauer * zuschauer * events);
      }
      return null;
    },
    animatedFormattedTraffic() {
      return (
        new Intl.NumberFormat("de-DE").format(Math.round(this.tweenedTraffic)) +
        " GB"
      );
    },
    eventdauerDisplay() {
      return this.eventdauer.toString();
    },
    zuschauerDisplay() {
      return this.zuschauer.toString();
    },
    eventsDisplay() {
      return this.events.toString();
    },
  },
  watch: {
    traffic(newVal) {
      this.$gsap.to(this.$data, {
        duration: 0.5,
        tweenedTraffic: newVal,
        ease: "power1.out",
      });
      this.showResetButton = newVal !== null;
    },
  },
  mounted() {
    this.tweenedTraffic = this.traffic;
  },
};
